module.exports = __webpack_public_path__ + "static/media/app-light-icon.7b64598c.svg";